<div class="edit-container">
    <h1 class="edit-title">Actualizează date imagine</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Categorie</mat-label>
                    <mat-select formControlName="id_category" (selectionChange)="onCategorieChange($event.value)">
                        <mat-option *ngFor="let categorie of categorii$ | async" [value]="categorie.id">
                            {{ categorie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.get('id_category')?.touched && form.get('id_category')?.errors?.['required']">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-error
                        *ngIf="form.get('id_category')?.touched && form.get('id_category')?.errors?.['notDefault']">
                        Selectați o opțiune
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Subcategorie</mat-label>
                    <mat-select formControlName="id_subcategory" (selectionChange)="onSubcategorieChange($event.value)">
                        <mat-option *ngFor="let subcategorie of subcategorii$ | async" [value]="subcategorie.id">
                            {{ subcategorie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.get('id_subcategory')?.touched && form.get('id_subcategory')?.errors?.['required']">
                        Selectați o opțiune
                    </mat-error>
                    <mat-error
                        *ngIf="form.get('id_subcategory')?.touched && form.get('id_subcategory')?.errors?.['notDefault']">
                        Selectați o opțiune
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Categorie terțiară</mat-label>
                    <mat-select formControlName="id_tertiary_category">
                        <mat-option *ngFor="let tertiara of categoriiTertiare$ | async" [value]="tertiara.id">
                            {{ tertiara.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.get('id_tertiary_category')?.touched && form.get('id_tertiary_category')?.errors?.['required']">
                        Selectați o opțiune
                    </mat-error>
                    <mat-error
                        *ngIf="form.get('id_tertiary_category')?.touched && form.get('id_tertiary_category')?.errors?.['notDefault']">
                        Selectați o opțiune
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>